import { ApiService } from "src/network/apiService";
import { IApiResponse } from "src/network/models/ApiResponse";
import { IBusinessListModel } from "src/types/models/apiModels";
import businessNumbers from "../../business-numbers/business-numbers";
import { request } from "http";

export interface IApproveBusinessNumbersRequest {
    businessNumbers: IApproveBusinessNumberRequest[]; // Business numbers that are valid and eligible for approval
}
export interface IApproveBusinessNumberRequest {
    businessNumber: string; // Business numbers that are valid and eligible for approval
    pilotSetupLimit?: number;
}

export class BusinessListViewModel {
    private apiService: ApiService;

    constructor(accessToken: string) {
        this.apiService = new ApiService({ accessToken: accessToken });
    }

    async fetchList(): Promise<IBusinessListModel[]> {
        const response = await this.apiService.getAsync<any>(
            "/onboard/business/unapproved-businesses"
        );

        if (response) {
            if (response.scResponse && response.scResponse.code === 2000) {
                const sortedBusinesses = response.scResponse.data.sort((a: { businessCode: number; }, b: { businessCode: number; }) => {
                    if (a.businessCode < b.businessCode) return -1; // a comes before b
                    if (a.businessCode > b.businessCode) return 1; // a comes after b
                    return 0; // a and b are equal
                });
                return sortedBusinesses;
            }

            return [];
        }

        return [];
    }

    async fetchBusiness(businessId: string): Promise<any | null> {
        const response = await this.apiService.getAsync<IApiResponse<any>>(
            `/onboard/business/${businessId}`
        );

        if (response) {
            if (response.scResponse && response.scResponse.code === 2000) {
                // console.log("GET: /onboard/business", JSON.stringify(response));
                return response.scResponse.data;
            }

            return null;
        }

        return null;
    }

    async approveBusinessNumber(businessId: string, businessNumber: string): Promise<boolean> {
        const request: IApproveBusinessNumbersRequest = {
            businessNumbers: [
                {
                    businessNumber: businessNumber,
                }
            ]
        }

        const response = await this.apiService.postAsync<IApiResponse<any>, IApproveBusinessNumbersRequest>(
            `/onboard/business/${businessId}/numbers/approve`,
            request
        );


        if (response) {
            if (response.scResponse && response.scResponse.code === 2000) {
                return true;
            }

            return false;
        }

        return false;
    }
}
